/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class transtype extends IceEntity {
  trans_type_key: string = "";
  connection_parameters_key: string = "";
  trans_type_code: IceTypes.TRANSTYPE = IceTypes.TRANSTYPE.itNone;
  connection_type: IceTypes.CONNECTIONTYPE = IceTypes.CONNECTIONTYPE.conntypNone;
  protocol_type: IceTypes.PROTOCOL = IceTypes.PROTOCOL.protocolNone;
  protocol_version: string = "";
  protocol_api: IceTypes.PROTOCOLAPI = IceTypes.PROTOCOLAPI.papiURL;
  protocol_api_version: string = "";
  transport_format: IceTypes.DATA_TRANSPORT_FORMAT = IceTypes.DATA_TRANSPORT_FORMAT.datatfmtNone;
  disabled: boolean = false;
  participating_type: IceTypes.participation_type = IceTypes.participation_type.pptParticipating;
  underdevelopment: boolean = false;
  contract_required: boolean = false;
  must_contact: boolean = false;
  test_required: boolean = false;
  submitter_trans_account: string = "";
  submitter_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
    return "TRANS_TYPE";
  }
}

